import { calendarConstants } from '../_constants/calendar.constants';
import {
  setIsFetching,
  filterCalendarResults, 
  resetCalendarResults,
  filterUserFund,
  filterCalendarByDate
} from '../_utils/calendar.utils';

const initialState = {
  calendarByYear: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  calendarByDate: {
    isFetching: false,
    data: [],
    errorMessage: null
  },
  calendarYear: (new Date()).getFullYear(),
  userFund: null,
  userDate: null,
  isOpenModal: false
};

const calendarReducer = (state = initialState, action) => {
  switch (action.type) {
    case calendarConstants.FETCH_CALENDAR_BY_YEAR_START:
      return {
        ...state,
        calendarByYear: setIsFetching(state.calendarByYear)
      };
    case calendarConstants.FETCH_CALENDAR_BY_YEAR_SUCCESS:
      return {
        ...state,
        calendarByYear: filterCalendarResults(state.calendarByYear, action.payload)
      };
    case calendarConstants.FETCH_CALENDAR_BY_YEAR_FAILURE:
      return {
        ...state,
        calendarByYear: resetCalendarResults(state.calendarByYear, action.payload)
      };
    case calendarConstants.UPDATE_CALENDAR_YEAR:
      return {
        ...state,
        calendarYear: action.payload
      };
    case calendarConstants.UPDATE_USER_FUND_CALENDAR:
      return {
        ...state,
        userFund: filterUserFund(action.payload)
      };
    case calendarConstants.UPDATE_USER_CALENDAR_DATE:
      return {
        ...state,
        userDate: action.payload
      };
    case calendarConstants.FETCH_CALENDAR_BY_DATE_START:
      return {
        ...state,
        calendarByDate: setIsFetching(state.calendarByDate)
      };
    case calendarConstants.FETCH_CALENDAR_BY_DATE_SUCCESS:
      return {
        ...state,
        calendarByDate: filterCalendarByDate(state.calendarByDate, action.payload)
      };
    case calendarConstants.FETCH_CALENDAR_BY_DATE_FAILURE:
      return {
        ...state,
        calendarByDate: resetCalendarResults(state.calendarByDate, action.payload)
      };
    default:
      return state;
  }
};

export default calendarReducer;
